module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-text-maedori1-beab4bfb554f5e959f41e96dccea6ac5.png";